import React, { useState, useEffect } from "react";
import { fetchCaseStudies } from "../../services/CaseStudyService";
import CaseStudyCard from "./CaseStudyCard";
import { Canvas } from "@react-three/fiber";
import CaseStudyCanvas from "./CaseStudyCanvas";
import useStore from "../../stores/store";

const LOCAL_DATA = [
  {
    id: 1,
    scope: [
      {
        id: 1,
        item: "E-commerce",
      },
      {
        id: 2,
        item: "Web Development",
      },
      {
        id: 3,
        item: "Graphic Design",
      },
      {
        id: 4,
        item: "MVP Development",
      },
      {
        id: 5,
        item: "App Development",
      },
      {
        id: 6,
        item: "Brand Strategy",
      },
      {
        id: 7,
        item: "Identity Design",
      },
      {
        id: 8,
        item: "Personalized Mentorship",
      },
      {
        id: 9,
        item: "Copywriting",
      },
      {
        id: 10,
        item: "Messaging",
      },
    ],
    challenges: [
      {
        id: 9,
        order: 0,
        item: "Swag Academy — New Venture",
        description:
          "Establish a new brand and revenue-generating offer from scratch, with limited initial investment.",
      },
      {
        id: 10,
        order: 0,
        item: "Swag Academy — Business Model",
        description:
          "Design a business model that can grow organically from its own profits, without relying on external funding.",
      },
      {
        id: 11,
        order: 0,
        item: "Swag Academy — MVP",
        description:
          "Minimize investment risk while validating the concept and developing the minimum viable product (MVP).",
      },
      {
        id: 12,
        order: 0,
        item: "Swag Academy — Elearning",
        description:
          "Create a compelling e-learning experience that stands out in a competitive market and resonates with Chris's target audience.",
      },
    ],
    testimonials: [
      {
        id: 2,
        order: 9,
        title: "Swag Academy — Chris Earns Millions",
        slug: "chris-earns-millions",
        author_name: "Chris Williams",
        company_logo: "",
        avatar:
          "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/chris-williams.jpg",
        role: "Founder",
        company: "The Swag Academy",
        quote:
          "My man!!! I just realized my site has been up for less than 6 months and I've almost made 2 MILLLLLION!!!! WHAT?!?!\r\n\r\nBro this is literally insane! I thought it was crazy when we hit my revenue goal for THE YEAR within 6 weeks of launching... and now I'm literally a millionaire! Thank you so much for helping me build the Swag Academy.",
        experience: 1,
      },
    ],
    experiences: [
      {
        id: 1,
        highlights: [
          {
            id: 2,
            icon: {
              id: 12,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Strategy",
              icon_id: "icon-strategy",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 31,
            title: "Sultan of Strategy",
            slug: "sultan-of-strategy",
            description:
              "I've engineered Wabbit's ascent by crafting bespoke research methodologies that guide our internal compass and client strategies, all while upholding our core philosophy of contrarian yet undeniably effective marketing.",
            experiences: [1],
          },
          {
            id: 3,
            icon: {
              id: 13,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Laptop",
              icon_id: "icon-data-detective",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 30,
            title: "Data Detective",
            slug: "data-detective",
            description:
              "I lead our team in mining insights from vast survey responses, unearthing the hidden gems that inform our tailored client strategies. We're guided not by dusty tomes, but by the living, breathing data of the real world.",
            experiences: [1],
          },
          {
            id: 4,
            icon: {
              id: 14,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Analytics",
              icon_id: "icon-analytics",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 29,
            title: "Analytics Ace",
            slug: "analytics-ace",
            description:
              "I create reporting frameworks that demystify the arcane languages of SEO, Google Analytics, and Google Tag Manager, empowering our team and clients with clarity and control.",
            experiences: [1],
          },
          {
            id: 5,
            icon: {
              id: 15,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Branding",
              icon_id: "icon-branding",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 28,
            title: "Brand Whisperer",
            slug: "brand-whisperer",
            description:
              "I navigate the tempestuous seas of the media landscape, steering the Wabbit brand through the straits of product-market fit and pivoting towards the beacons of opportunity that make our tribe shine brightest.",
            experiences: [1],
          },
          {
            id: 6,
            icon: {
              id: 16,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Copywriting",
              icon_id: "icon-copywriting",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 27,
            title: "King of Kopywriting",
            slug: "king-of-kopywriting",
            description:
              "With a legion of scripts and evergreen content created, I've helped clients boost engagement by 40%. The secret? It's the alchemy of carefully crafted narratives that resonates with audiences.",
            experiences: [1],
          },
          {
            id: 7,
            icon: {
              id: 17,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Leader",
              icon_id: "icon-leader",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 26,
            title: "Leader of the Rebels",
            slug: "leader-of-the-rebels",
            description:
              "I guide a team of unstoppable creative insurgents, delivering jaw-dropping web design and shockingly effective email campaigns. We're the guerillas in the mist of the marketing world.",
            experiences: [1],
          },
          {
            id: 8,
            icon: {
              id: 18,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Educator",
              icon_id: "icon-educator",
            },
            projects: [
              {
                id: 1,
                icon: {
                  id: 3,
                  sprite_sheet: {
                    id: 7,
                    name: "icons-projects",
                    filename: "sprite-icons-projects",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-projects.svg",
                  },
                  name: "PROJECT -- Wabbit-Bunny",
                  icon_id: "bunny",
                },
                background_icon: {
                  id: 8,
                  sprite_sheet: {
                    id: 8,
                    name: "icon-backgrounds",
                    filename: "sprite-icon-backgrounds",
                    fileURL:
                      "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
                  },
                  name: "Background__Circle-3",
                  icon_id: "icon--background-3",
                },
                category: {
                  id: 1,
                  name: "Entrepreneurship",
                  slug: "entrepreneurship",
                  order: 3,
                  description: "Entrepreneurship",
                },
                skills: [],
                name: "Wabbit",
                thumbnail_img:
                  "https://site-davidbickley.s3.amazonaws.com/projects/wabbit.jpg",
                featured_img: null,
                url: "http://wabbit.com",
                slug: "wabbit",
                order: 1,
                description:
                  "What began as a beer-fueled bet has become an all-out adventure. This is more than a marketing case-study; it's a living chronicle of the journey.",
                status: "current",
                is_featured: true,
                is_published: false,
              },
            ],
            order: 25,
            title: "Educator-in-Chief",
            slug: "educator-in-chief",
            description:
              "I poured my heart into creating our flagship course from scratch. The late nights were worth it – it now boasts a 95% completion rate and a 4.8/5 rating from participants.",
            experiences: [1],
          },
        ],
        testimonials: [
          {
            id: 12,
            order: 0,
            title: "Even with a small audience",
            slug: "even-with-a-small-audience",
            author_name: "Austin Budlovich",
            company_logo: "",
            avatar:
              "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/Leaf-Loft-Co-Founder-Austin-150x150.jpg",
            role: "Co-Founder",
            company: "Leaf Loft Botanicals",
            quote:
              "In our first day, with a small audience, we still made several hundred dollars in profit within the first hour of launching. Now, less than one year of consistent growth later, we just finished our best month ever with $7,500 profit!",
            experience: 1,
          },
          {
            id: 11,
            order: 0,
            title: "David reframed how we approach growth",
            slug: "david-reframed-how-we-approach-growth",
            author_name: "Kelsey Shaffer",
            company_logo: "",
            avatar:
              "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/Leaf-Loft-Co-Founder-Kelsey-150x150.jpg",
            role: "Co-Founder",
            company: "Leaf Loft Botanicals",
            quote:
              "David not only built us an incredible site, he helped us completely reframe the ways we approach the growth of our company.",
            experience: 1,
          },
          {
            id: 13,
            order: 0,
            title: "The Atelier Site",
            slug: "the-atelier-site",
            author_name: "Meg Ferguson",
            company_logo: "",
            avatar:
              "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/atelier-founder-meg-ferguson_150x150.jpg",
            role: "Owner",
            company: "The Atelier Co.",
            quote:
              "David did such amazing job getting my store set up, and his marketing guidance is utterly game-changing! I'm stunned at how many sales come through our site.",
            experience: 1,
          },
          {
            id: 15,
            order: 0,
            title: "Hiring David was wise",
            slug: "hiring-david-was-wise",
            author_name: "John Rake",
            company_logo: "",
            avatar:
              "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/flowstate-co-founder-john-rake_150x150.jpg",
            role: "Co-founder",
            company: "FlowState Systems",
            quote:
              "Hiring David to guide design and development might be the wisest decision we have ever made for our business.",
            experience: 1,
          },
          {
            id: 2,
            order: 9,
            title: "Swag Academy — Chris Earns Millions",
            slug: "chris-earns-millions",
            author_name: "Chris Williams",
            company_logo: "",
            avatar:
              "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/chris-williams.jpg",
            role: "Founder",
            company: "The Swag Academy",
            quote:
              "My man!!! I just realized my site has been up for less than 6 months and I've almost made 2 MILLLLLION!!!! WHAT?!?!\r\n\r\nBro this is literally insane! I thought it was crazy when we hit my revenue goal for THE YEAR within 6 weeks of launching... and now I'm literally a millionaire! Thank you so much for helping me build the Swag Academy.",
            experience: 1,
          },
          {
            id: 1,
            order: 10,
            title: "Obvious Products — Sarah thanks the Wabbits",
            slug: "sarah-thanks-the-wabbits",
            author_name: "Sarah Muntean",
            company_logo: "",
            avatar:
              "https://site-davidbickley.s3.amazonaws.com/testimonials/avatars/sarah-muntean.jpg",
            role: "Founder",
            company: "Obvious Products",
            quote:
              "Just wanted to take a moment to say THANK YOU for the phenomenal job you and the Wabbits did on my new website. I'm over the moon with how it turned out! 🚀\r\n\r\nYou know, it's funny. When we first started working together, I had no idea how much of a difference Wabbit would make for my startup. The site, and everything we chatted about along the way has seriously leveled up my networking game with vendors, prospects, and investors. They take me seriously now, giving me a feeling of credibility and confidence I never had before. Thank you so much!",
            experience: 1,
          },
        ],
        logo: {
          id: 4,
          sprite_sheet: {
            id: 5,
            name: "logos",
            filename: "sprite-logos",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-logos.svg",
          },
          name: "Wabbit",
          logo_id: "logo-wabbit",
        },
        skills: [
          {
            id: 12,
            icon: {
              id: 107,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Product-Development",
              icon_id: "skill-product-development",
            },
            background_icon: null,
            name: "Product Development",
            slug: "product-development",
            order: 0,
            description:
              "Beginning at the intersection of what the audience needs, and what we can (or are willing to) do, I help companies create offers that fit.",
            skill_level: "novice",
          },
          {
            id: 13,
            icon: {
              id: 106,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Communication",
              icon_id: "skill-communication",
            },
            background_icon: null,
            name: "Communication",
            slug: "communication",
            order: 0,
            description: "I talk messaging gud.",
            skill_level: "novice",
          },
          {
            id: 14,
            icon: {
              id: 100,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Leadership",
              icon_id: "skill-leadership",
            },
            background_icon: null,
            name: "Leadership",
            slug: "leadership",
            order: 0,
            description:
              "When asked to lead, I do so by serving in the trenches with my team — and removing roadblocks wherever possible so those skilled people can do great things.",
            skill_level: "novice",
          },
          {
            id: 23,
            icon: {
              id: 94,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Content-Strategy",
              icon_id: "skill-content-strategy",
            },
            background_icon: null,
            name: "Content Strategy",
            slug: "content-strategy",
            order: 0,
            description:
              "You'll never find me padding a blog for better search rankings.\r\n\r\nInstead, I work with teams to craft compelling, targeted (hopefully evergreen) narratives that engage, inform, and inspire action in their audiences.\r\n\r\nThen, we iterate on the successful narratives and run them through the proper traction channel.",
            skill_level: "novice",
          },
          {
            id: 5,
            icon: {
              id: 32,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Code-Screen",
              icon_id: "icon-code-screen",
            },
            background_icon: null,
            name: "Web Development",
            slug: "web-development",
            order: 0,
            description:
              "In some fashion or another, I've built websites since my teen years. But it wasn't until the 2020's that I could dare call myself a professional developer.\r\n\r\nThese days I spend my time building digital experiences that are intuitive, engaging, and performant.\r\n\r\nSometimes that means working with Wordpress, Shopify, etc....\r\n\r\nMostly it means building bespoke assets like the one you're on right now.",
            skill_level: "novice",
          },
          {
            id: 21,
            icon: {
              id: 96,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Time-Management",
              icon_id: "skill-time-management",
            },
            background_icon: null,
            name: "Time Management",
            slug: "time-management",
            order: 0,
            description:
              "The years spent tracking billable time while battling ADHD have made me hyper-aware of where my hours go, and I keep myself on track.\r\n\r\nAfter all, time is the only currency we have.\r\n\r\nSo I guard mine ferociously.",
            skill_level: "novice",
          },
          {
            id: 22,
            icon: {
              id: 95,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Teamwork",
              icon_id: "skill-teamwork",
            },
            background_icon: null,
            name: "Teamwork",
            slug: "teamwork",
            order: 0,
            description:
              "Of all the work there is to do in the world, my favorite style is collaborative.\r\n\r\nSure, I love some focused solo time too, but...\r\n\r\nThere's something priceless in the dance, the trades, the call and response of teamwork. \r\n\r\nTo me, it is pure joy to collaborate with other minds and co-create something greater than the sum of its parts.",
            skill_level: "novice",
          },
          {
            id: 15,
            icon: {
              id: 99,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Problem-Solving",
              icon_id: "skill-problem-solving",
            },
            background_icon: null,
            name: "Problem Solving",
            slug: "problem-solving",
            order: 0,
            description:
              "Einstien said:\r\n\r\n\"It's not that I'm smarter than anyone, it's that I stick with problems longer.\"\r\n\r\nI'm not comparing myself to him, but I did take his words to heart. I'm absolutely relentless about solving the problems given to me.",
            skill_level: "novice",
          },
          {
            id: 16,
            icon: {
              id: 92,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Advertising",
              icon_id: "skill-advertising",
            },
            background_icon: null,
            name: "Advertising",
            slug: "advertising",
            order: 0,
            description:
              "Advertising gets a bad rap because of how many people do it poorly. I hate it too.\r\n\r\nStill, running ads is a fantastically reliable way of generating leads. And there are plenty of way to do it without being repellent.\r\n\r\nBut you have to know how to craft messages that cut through the noise and drive those results.\r\n\r\nI do.",
            skill_level: "novice",
          },
          {
            id: 17,
            icon: {
              id: 98,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Cooperation",
              icon_id: "skill-cooperation",
            },
            background_icon: null,
            name: "Cooperation",
            slug: "cooperation",
            order: 0,
            description:
              "Whether it's with the customer, client, or team, my default stance is co-creation. \r\n\r\nWhatever we do, we are in it together.\r\n\r\nFostering that spirit of teamwork and mutual support is, in my opinion, the most important ingredient in achieving shared goals.",
            skill_level: "novice",
          },
          {
            id: 7,
            icon: {
              id: 103,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Visual-Design",
              icon_id: "skill-visual-design",
            },
            background_icon: null,
            name: "Visual Design",
            slug: "visual-design",
            order: 0,
            description:
              "More than making things pretty, unique, or clever, good design is about communication.\r\n\r\nSkilled designers make it easier for the audience to process information. This can be as simple as breaking long text into headers and bullet points, or as complex as this site, and beyond.",
            skill_level: "novice",
          },
          {
            id: 6,
            icon: {
              id: 102,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Creative-Direction",
              icon_id: "skill-creative-direction",
            },
            background_icon: null,
            name: "Creative Direction",
            slug: "creative-direction",
            order: 0,
            description:
              "This work involves generating fresh ideas, solving problems, and guiding a team to bring the vision to life. It's about understanding what the audience wants and needs, while also pushing boundaries to create something unique and cohesive.",
            skill_level: "novice",
          },
          {
            id: 1,
            icon: {
              id: 44,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Computer-Science",
              icon_id: "icon-computer-science",
            },
            background_icon: null,
            name: "Software Engineering",
            slug: "software-engineering",
            order: 4,
            description:
              "A skill I picked up later in life, and one I am enjoying tremendously. \r\n\r\nI'm excited by the creative implications of being able to express ideas and interactive experiences in code. And I'm happy to be finally be able to contribute to the world in this way.",
            skill_level: "novice",
          },
          {
            id: 2,
            icon: {
              id: 91,
              sprite_sheet: {
                id: 14,
                name: "icons-skills",
                filename: "sprite-icons-skills",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-skills.svg",
              },
              name: "ICON--Skill--Marketing",
              icon_id: "skill-marketing",
            },
            background_icon: null,
            name: "Marketing",
            slug: "marketing",
            order: 3,
            description:
              "I help people connect with the audience they seek to serve.\r\n\r\nFrom developing the grand strategies and tactical implementations, to executing the line-level work required to make campaigns happen, after 20 years in the trenches, I've done it all.",
            skill_level: "novice",
          },
          {
            id: 8,
            icon: {
              id: 16,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Copywriting",
              icon_id: "icon-copywriting",
            },
            background_icon: null,
            name: "Copywriting",
            slug: "copywriting",
            order: 0,
            description:
              "I wouldn't go so far as calling myself a copywriter. I'm not a pro. \r\n\r\nStill, I've written hundreds of thousands of words of content in the franken-categories of advertorials and edutainment. \r\n\r\nMore importantly, I know how to split-test the work and use that data to hone the copy over time.",
            skill_level: "novice",
          },
          {
            id: 18,
            icon: {
              id: 15,
              sprite_sheet: {
                id: 15,
                name: "icons-highlights",
                filename: "sprite-icons-highlights",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-highlights.svg",
              },
              name: "ICON--Highlights--Branding",
              icon_id: "icon-branding",
            },
            background_icon: null,
            name: "Branding",
            slug: "branding",
            order: 0,
            description:
              "Often confused with logo design, my kind of branding is about building authentic, memorable, and cohesive identities that are reflected in every corner of the company.",
            skill_level: "novice",
          },
        ],
        technologies: [
          {
            id: 7,
            icon: {
              id: 81,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-Node",
              icon_id: "tech-node",
            },
            background_icon: null,
            name: "NodeJS",
            slug: "nodejs",
            order: 13,
            description:
              "A versatile JavaScript runtime that allows me to build scalable, server-side applications.",
            skill_level: "novice",
          },
          {
            id: 10,
            icon: {
              id: 82,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-React",
              icon_id: "tech-react",
            },
            background_icon: null,
            name: "React",
            slug: "react",
            order: 10,
            description:
              "A powerful JavaScript library for building interactive, reusable UI components.",
            skill_level: "novice",
          },
          {
            id: 11,
            icon: {
              id: 83,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-Redux",
              icon_id: "tech-redux",
            },
            background_icon: null,
            name: "Redux",
            slug: "redux",
            order: 9,
            description:
              "A state management library that helps me keep complex application states under control.",
            skill_level: "novice",
          },
          {
            id: 3,
            icon: {
              id: 85,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-HTML5",
              icon_id: "tech-html5",
            },
            background_icon: null,
            name: "HTML 5",
            slug: "html-5",
            order: 17,
            description:
              "The markup language that provides the structure and content for my web creations.",
            skill_level: "novice",
          },
          {
            id: 4,
            icon: {
              id: 86,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-CSS3",
              icon_id: "tech-css3",
            },
            background_icon: null,
            name: "CSS3",
            slug: "css3",
            order: 16,
            description:
              "The styling language that gives my web pages their unique look and feel.",
            skill_level: "novice",
          },
          {
            id: 6,
            icon: {
              id: 84,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-Javascript",
              icon_id: "tech-javascript",
            },
            background_icon: null,
            name: "Javascript",
            slug: "javascript",
            order: 14,
            description:
              "The versatile language that powers many of my interactive web experiences, front and back.",
            skill_level: "novice",
          },
          {
            id: 17,
            icon: {
              id: 87,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-Wordpress",
              icon_id: "tech-wordpress",
            },
            background_icon: null,
            name: "Wordpress",
            slug: "wordpress",
            order: 3,
            description:
              "The trusty CMS powering many of my web projects, offering flexibility and reliability.",
            skill_level: "novice",
          },
          {
            id: 18,
            icon: {
              id: 88,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech--Photoshop",
              icon_id: "tech-photoshop",
            },
            background_icon: null,
            name: "Adobe Photoshop",
            slug: "adobe-photoshop",
            order: 2,
            description:
              "The place where I enhance, manipulate, and create stunning visual assets.",
            skill_level: "novice",
          },
          {
            id: 19,
            icon: {
              id: 89,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-Illustrator",
              icon_id: "tech-illustrator",
            },
            background_icon: null,
            name: "Adobe Illustrator",
            slug: "adobe-illustrator",
            order: 1,
            description:
              "Where I create scalable, versatile graphics that look crisp on any screen or print.",
            skill_level: "novice",
          },
          {
            id: 1,
            icon: {
              id: 90,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech-Python",
              icon_id: "tech-python",
            },
            background_icon: null,
            name: "Python",
            slug: "python",
            order: 19,
            description:
              "A powerful, versatile programming language that I use for a wide range of tasks, from web development to data analysis.",
            skill_level: "novice",
          },
          {
            id: 2,
            icon: {
              id: 109,
              sprite_sheet: {
                id: 13,
                name: "icons-tech",
                filename: "sprite-icons-tech",
                fileURL:
                  "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
              },
              name: "ICON--Tech--Django",
              icon_id: "tech-django",
            },
            background_icon: null,
            name: "Django",
            slug: "django",
            order: 18,
            description:
              "A high-level Python web framework that enables rapid development of secure, scalable web apps.",
            skill_level: "novice",
          },
        ],
        projects: [],
        background_icon: {
          id: 6,
          sprite_sheet: {
            id: 8,
            name: "icon-backgrounds",
            filename: "sprite-icon-backgrounds",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icon-backgrounds.svg",
          },
          name: "Background__Circle-1",
          icon_id: "icon--background-1",
        },
        order: 2,
        company: "Wabbit",
        slug: "wabbit",
        role_title: "Lead Marketing Technologist",
        start_year: "2017",
        end_year: "Present",
        excerpt:
          "Wabbit is a challenge to modern marketing norms, proof you can defy the status quo and win.",
        description:
          "Wabbit started as a simple idea: generate Monthly Recurring Revenue by churning out budget WordPress sites for startups — but, four years in, I spotted a golden opportunity to mentor game developers in marketing. \r\n\r\nWe couldn't resist. \r\n\r\nThe catch? To understand them, I had to become one of them.\r\n\r\nSuddenly, I'm eyeballs-deep in computer science, building games and software from scratch...\r\n\r\nBut now? I speak their language, and I'm in love with the community. \r\n\r\nThere's no telling what's at the end of this road, but I'm loving every step of the journey.",
        tldr: "I am literally responsible for everything.",
      },
    ],
    projects: [],
    credits: [
      {
        id: 3,
        order: 1,
        role: "Support Team",
        name: "Dominique Lucca",
        is_featured: false,
        case_study: 1,
      },
      {
        id: 2,
        order: 2,
        role: "Support Team",
        name: "Nilaja Wyatt",
        is_featured: false,
        case_study: 1,
      },
      {
        id: 1,
        order: 3,
        role: "Photographer / Videographer",
        name: "Austin Wilcox",
        is_featured: false,
        case_study: 1,
      },
    ],
    skills: [],
    technologies: [
      {
        id: 3,
        icon: {
          id: 85,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech-HTML5",
          icon_id: "tech-html5",
        },
        background_icon: null,
        name: "HTML 5",
        slug: "html-5",
        order: 17,
        description:
          "The markup language that provides the structure and content for my web creations.",
        skill_level: "novice",
      },
      {
        id: 4,
        icon: {
          id: 86,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech-CSS3",
          icon_id: "tech-css3",
        },
        background_icon: null,
        name: "CSS3",
        slug: "css3",
        order: 16,
        description:
          "The styling language that gives my web pages their unique look and feel.",
        skill_level: "novice",
      },
      {
        id: 5,
        icon: {
          id: 115,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech--SCSS",
          icon_id: "tech-scss",
        },
        background_icon: null,
        name: "SCSS",
        slug: "scss",
        order: 15,
        description:
          "A CSS preprocessor that makes writing and maintaining stylesheets more efficient and modular.",
        skill_level: "novice",
      },
      {
        id: 6,
        icon: {
          id: 84,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech-Javascript",
          icon_id: "tech-javascript",
        },
        background_icon: null,
        name: "Javascript",
        slug: "javascript",
        order: 14,
        description:
          "The versatile language that powers many of my interactive web experiences, front and back.",
        skill_level: "novice",
      },
      {
        id: 17,
        icon: {
          id: 87,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech-Wordpress",
          icon_id: "tech-wordpress",
        },
        background_icon: null,
        name: "Wordpress",
        slug: "wordpress",
        order: 3,
        description:
          "The trusty CMS powering many of my web projects, offering flexibility and reliability.",
        skill_level: "novice",
      },
      {
        id: 18,
        icon: {
          id: 88,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech--Photoshop",
          icon_id: "tech-photoshop",
        },
        background_icon: null,
        name: "Adobe Photoshop",
        slug: "adobe-photoshop",
        order: 2,
        description:
          "The place where I enhance, manipulate, and create stunning visual assets.",
        skill_level: "novice",
      },
      {
        id: 19,
        icon: {
          id: 89,
          sprite_sheet: {
            id: 13,
            name: "icons-tech",
            filename: "sprite-icons-tech",
            fileURL:
              "https://site-davidbickley.s3.amazonaws.com/sprite-sheets/sprite-icons-tech.svg",
          },
          name: "ICON--Tech-Illustrator",
          icon_id: "tech-illustrator",
        },
        background_icon: null,
        name: "Adobe Illustrator",
        slug: "adobe-illustrator",
        order: 1,
        description:
          "Where I create scalable, versatile graphics that look crisp on any screen or print.",
        skill_level: "novice",
      },
    ],
    phases: [
      {
        id: 6,
        title: "Building Momentum",
        description:
          "With proof of concept in hand, we reinvested 25% of profits into brand development and platform enhancements. Based on customer feedback, we added robust community features to foster a sense of belonging and support among students. Within three months, membership had grown to over 300 students, despite a price increase.",
        img: "https://site-davidbickley.s3.amazonaws.com/case_studies/swag-academy_phase-2_h550.png",
        order: 2,
        case_study: 1,
      },
      {
        id: 7,
        title: "Expanding Horizons",
        description:
          "As Swag Academy continued to grow, we knew it was time to take the platform to the next level. We upgraded to a full-featured e-learning system with courses, lesson tracking, quizzes, and enhanced social interaction. By continuously refining the platform based on user feedback and behavior analytics, we ensured that Swag Academy remained at the forefront of the industry.",
        img: "https://site-davidbickley.s3.amazonaws.com/case_studies/swag-academy_phase-3_h550.png",
        order: 3,
        case_study: 1,
      },
      {
        id: 8,
        title: "Optimizing Performance",
        description:
          "In an effort to optimize costs, we experimented with an out-of-the-box membership and LMS solution. However, it quickly became apparent that a custom solution was necessary to support Swag Academy's rapid growth. This willingness to test, learn, and adapt was crucial to the company's ongoing success.",
        img: "https://site-davidbickley.s3.amazonaws.com/case_studies/swag-academy_kajabi_h550.png",
        order: 4,
        case_study: 1,
      },
      {
        id: 9,
        title: "Dominating the Market",
        description:
          "With a clear understanding of our users' needs and preferences, we conducted extensive research to inform a complete redesign of the Swag Academy platform. We implemented advanced analytics and reporting features to track key performance metrics, developed custom staff training modules to streamline onboarding, and launched a branded mobile app to provide students with on-the-go access to their courses. These enhancements solidified Swag Academy's position as the leader in Forex education.",
        img: "https://site-davidbickley.s3.amazonaws.com/case_studies/swag-academy_phase-5_h550.png",
        order: 5,
        case_study: 1,
      },
      {
        id: 5,
        title: "Charting the Course",
        description:
          "We began by launching a simple, low-cost MVP to test market demand and validate the concept. With an initial investment of just $250, we enrolled 66 students at a premium price point, generating an astonishing ROI of over 2,000% in the first month. \r\n\r\nThis early success proved that Chris's vision had legs, giving us a strong signal to move forward.",
        img: "https://site-davidbickley.s3.amazonaws.com/case_studies/swag-academy_phase-1_h550.png",
        order: 1,
        case_study: 1,
      },
    ],
    outcomes: [
      {
        id: 2,
        description:
          "In close collaboration with Chris and his team, we launched Swag Academy, a groundbreaking Forex education platform that quickly established itself as a leader in the industry. \r\n\r\nFrom humble beginnings as a simple website with personalized mentorship, Swag Academy grew into a thriving, multi-million dollar business with a loyal community of over 20,000 students.",
        order: 0,
        case_study: 1,
      },
    ],
    impacts: [
      {
        id: 2,
        description:
          "Swag Academy's meteoric rise is a testament to the power of a clear vision, a customer-centric approach, and a relentless drive to succeed.\r\n\r\n2,000+ members and a multi-million dollar valuation within the first year.\r\n13,000+ members by the end of 2021.\r\n20,000+ members by early 2022.\r\n\r\nCountless lives transformed through financial education and community support.",
        order: 0,
        case_study: 1,
      },
    ],
    backstory: {
      id: 2,
      content:
        "Before Swag Academy, Chris Williams found himself [at a crossroads](https://markets.businessinsider.com/news/stocks/chris-swaggy-c-williams-initially-known-for-his-tv-appearances-is-now-a-multi-millionaire-and-is-helping-others-achieve-success-1029675486). Despite his reality TV fame, he was $106,000 in debt and watching his credit score plummet. Determined to turn his life around, Chris realized that his true passion lay in investing and entrepreneurship.\r\n\r\nAs a novice entrepreneur, Chris knew he needed more than just a website; he needed a strategic partner who could guide him through the process of building a lean, profitable business from scratch. He found me.",
      img: "https://site-davidbickley.s3.amazonaws.com/case_studies/backstory/the-swag-academy_backstory_h550.jpg",
      case_study: 1,
    },
    goal: {
      id: 2,
      content:
        "Swag Academy set out to revolutionize the Forex education industry by creating a platform that not only provided top-notch content but also fostered a sense of community and belonging. By leveraging Chris's personal brand and trading expertise, the company aimed to help students navigate the challenges of Forex trading and achieve their financial goals.",
      img: null,
      case_study: 1,
    },
    gap: {
      id: 2,
      content:
        "The Forex education market was rife with opportunities for improvement. Existing products often fell short in terms of community building, production value, and mobile accessibility. Swag Academy recognized these gaps and set out to create a more comprehensive, user-centric e-learning experience.",
      img: null,
      case_study: 1,
    },
    gamble: {
      id: 2,
      content:
        "Launching a new e-learning platform in a competitive market was a significant risk. Swag Academy needed to differentiate itself quickly and build a loyal customer base to succeed. Investing in a custom, high-quality platform tailored to the needs of Chris's target audience was a bold move, but one that had the potential to pay off big.",
      img: null,
      case_study: 1,
    },
    name: "6 Month Millionaire",
    client_name: "Chris Williams",
    company: "The Swag Academy",
    slug: "the-swag-academy",
    order: 1,
    excerpt:
      "You see an opportunity to open an online school, but you have no idea how to build something like that. What is the best way to approach the project?",
    mission:
      'Chris "Swaggy C" Williams, a reality TV star with a passion for Forex trading, came to me with a dream: to create a life-changing e-learning platform that could help people achieve financial freedom. \r\n\r\nWith a large social media following but no clear path to monetization, Chris needed a partner who could help him build a profitable business from the ground up.',
    approach:
      "To bring The Swag Academy to life, I proposed a phased approach that would allow Chris to launch quickly, validate his business model with his target audience, and scale efficiently.\r\n\r\nBy focusing on the essential elements first and building out additional functionality incrementally, The Swag Academy could enter the market sooner, gather real customer feedback, and make data-driven decisions about future enhancements to continuously optimize the student experience.\r\n\r\nThis agile methodology mitigated risk, optimized resources, and ensured the e-learning platform evolved in lockstep with the company's growth and understanding of their audience.",
    closing_thoughts:
      "Swag Academy's incredible success story demonstrates the power of a clear vision, a customer-centric approach, and a willingness to adapt and evolve based on data and feedback. By partnering with me, an established expert, and embracing a lean, iterative strategy, Chris was able to transform his personal brand into a multi-million dollar e-learning business in record time.\r\n\r\nWhile this rapid growth is a testament to the strength of Swag Academy's offering and Chris's work ethic, it's important to recognize that this level of success is not easily achieved. As one of my first test students in Wabbit EDU, Chris had access to invaluable guidance and support throughout his entrepreneurial journey, which played a significant role in shaping the company's trajectory.\r\n\r\nSwag Academy's story serves as an inspiration to aspiring entrepreneurs and a powerful case study for the principles and strategies at play. \r\n\r\nI am immensely proud to have been part of this remarkable journey and look forward to seeing Chris continue to thrive in the years to come.",
    featured_img:
      "https://site-davidbickley.s3.amazonaws.com/case_studies/the-swag-academy_case-study_featured_w1200.jpg",
    thumbnail_img:
      "https://site-davidbickley.s3.amazonaws.com/case_studies/the-swag-academy_case-study_thumbnail_w450.jpg",
    published_date: null,
    is_published: false,
    category: null,
  },
];

const CaseStudyList = () => {
  const [caseStudies, setCaseStudies] = useState(LOCAL_DATA);
  const { theme } = useStore();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await fetchCaseStudies();
  //       const sortedData = data.sort((a, b) => a.order - b.order);
  //       setCaseStudies(sortedData);
  //     } catch (error) {
  //       console.error("Error fetching experiences:", error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  return (
    <div style={{ width: "100%", height: "100vh" }}>
      <CaseStudyCanvas caseStudies={caseStudies} />
    </div>
  );
};

export default CaseStudyList;
